export default __webpack_public_path__ + "static/media/image.ee60fb93.svg";